export const FOUNDER_PATHS = [
  { name: 'Dashboard', path: '/founder/dashboard', icon: '/images/dashboard-icon.svg' },
  { name: 'Raises', path: '/founder/deals', icon: '/images/portfolio-icon.svg' },
  { name: 'Deal Rooms', path: '/founder/rooms', icon: '/images/portfolio-icon.svg' },
  { name: 'Pipeline', path: '/founder/pipelines', icon: '/images/pipeline-icon.svg' },
  { name: 'Investors', path: '/founder/investors', icon: '/images/pipeline-icon.svg' },
  { name: 'Team', path: '/founder/team', icon: '/images/team-icon.svg' },
  { name: 'Vault', path: '/founder/vault', icon: '/images/data-vault.svg' },
  { name: 'Settings', path: '/founder/settings', icon: '/images/settings-icon.svg' },
];

export const INVESTOR_PATHS = [
  { name: 'Dashboard', path: '/investor/dashboard', icon: '/images/dashboard-icon.svg' },
  { name: 'Dealflow', path: '/investor/dealflow', icon: '/images/pipeline-icon.svg' },
  { name: 'Portfolio', path: '/investor/portfolio', icon: '/images/portfolio-icon.svg' },
  { name: 'Team', path: '/investor/team', icon: '/images/team-icon.svg' },
  { name: 'Settings', path: '/investor/settings', icon: '/images/settings-icon.svg' },
];

export const BTN_STYLE = 'title-shadow bg-transparent border-0 me-32 p-4';

export const checkPath = (path, pathname, related) => {
  const linkActive = 'text-dark fw-600 m-0';
  const linkMuted = 'text-gray-400 m-0';
  return (path.includes(pathname) || related?.filter(e => path.includes(e))?.length) ? linkActive : linkMuted;
};

export const clearAndNavigate = (typeId, newPath, navigate) => {
  navigate(newPath);
};
